export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-primary-100/80 text-primary-700 mb-4 whitespace-nowrap">
              热门吃瓜 · 每日更新
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-foreground-950 mb-4">
              51吃瓜网在线观看
              <br />
              <span className="text-primary-500">全网最全娱乐八卦平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-5">
              一手吃瓜，不落人后。51吃瓜网汇聚全网热门娱乐资讯、明星八卦、综艺爆料与影视动态，
              每日24小时持续追踪更新，覆盖微博、抖音、小红书等100+内容源头，做你身边最快最全的吃瓜导航站。
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6">
              不论是最新影视剧透、综艺热点、明星动态还是热门话题事件，51吃瓜网在线观看为你一站式聚合全网吃瓜入口，
              站内导航直达各大平台官方入口，告别搜索烦恼，让每次吃瓜都先人一步。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <strong className="text-accent-600">日均更新300+</strong>
                <span className="text-foreground-400">条资讯</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <strong className="text-primary-600">覆盖全网100+</strong>
                <span className="text-foreground-400">源头</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <strong className="text-accent-600">7×24小时</strong>
                <span className="text-foreground-400">持续追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#index');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                立即吃瓜
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#about');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-secondary-300 text-foreground-700 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:border-secondary-400 hover:bg-background-100 transition-colors"
              >
                了解我们
                <i className="ri-information-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20editorial%20illustration%20with%20warm%20coral%20red%20and%20amber%20gradients%2C%20stylized%20speech%20bubbles%20and%20news%20fragments%20floating%20in%20dynamic%20composition%2C%20modern%20flat%20design%20with%20soft%20shadows%2C%20entertainment%20media%20theme%2C%20clean%20minimal%20background%20with%20subtle%20geometric%20patterns%2C%20warm%20atmospheric%20lighting%2C%20professional%20editorial%20layout%20feel&width=1040&height=780&seq=hero-main-2026&orientation=landscape"
                alt="51吃瓜网在线观看 - 全网娱乐八卦平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}